export const SuggestionActionType = {
  REPLACE: 0,
  COMPOSE: 1,
}
